import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

export const getMapData = (zip: number) => {
    //@ts-ignore
    return axios.get(API_URL + `users-map/${zip}`, { headers: authHeader() });
};